import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_BASE_URL } from '../services/api/api-base-url.token';

const isAbsolute = (url: string): boolean => /^https?:\/\//i.test(url.trim());
const isStaticAsset = (url: string): boolean => /^(?:\.\/)?\/?assets\/.+\.[a-z0-9]+(\?|#|$)/i.test(url);

export const apiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (isAbsolute(req.url) || isStaticAsset(req.url)) return next(req);
  const base = inject(API_BASE_URL).replace(/\/$/, '');
  const path = req.url.startsWith('/') ? req.url : `/${req.url}`;
  return next(req.clone({ url: `${base}${path}` }));
};
